import { render, staticRenderFns } from "./MutationPoints.vue?vue&type=template&id=bcd01278&scoped=true&"
import script from "./MutationPoints.vue?vue&type=script&lang=ts&"
export * from "./MutationPoints.vue?vue&type=script&lang=ts&"
import style0 from "./MutationPoints.vue?vue&type=style&index=0&id=bcd01278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd01278",
  null
  
)

export default component.exports